import { useTracks } from "@livekit/components-react";
import classNames from "./Overlay.module.css";
import { RoomEvent, Track } from "livekit-client";
import Captions from "./Captions";
import MeetingParticipant from "../routes/meeting/MeetingParticipant";
import { useRenderLanguage } from "../../hooks/user";
import MicToggle from "./MicToggle";
import CameraToggle from "./CameraToggle";

export default function Overlay() {
  const tracks = useTracks(
    [{ source: Track.Source.Camera, withPlaceholder: true }],
    { updateOnlyOn: [RoomEvent.ActiveSpeakersChanged], onlySubscribed: false }
  );

  const renderLanguage = useRenderLanguage();

  return (
    <div className={classNames.Overlay}>
      {/* Show self, top speaker, captions, and controls */}
      <div className={classNames.OverlayParticipants}>
        {tracks
          .filter((t) => !t.participant.isAgent)
          .slice(0, 2)
          .map((track, index) => (
            <div>
              <MeetingParticipant key={index} trackRef={track} />
            </div>
          ))}
      </div>

      <div className={classNames.Captions}>
        <Captions renderLanguage={renderLanguage} />
      </div>
      <div className={classNames.OverlayControls}>
        <MicToggle className={classNames.TrackToggle} />
        <CameraToggle className={classNames.TrackToggle} />
      </div>
    </div>
  );
}
